// src/api/ITapi.js
//
// Migrated off raw fetch() onto the shared axios instance in ./client.js.
// The token header and error-body reading this file used to hand-roll
// (tokenHeader()/handle()) are now done centrally by client.js's request
// interceptor and getApiError() helper — dropped here as dead code.
import { api, getApiError } from "./client";

// --------------------
// Current user
// --------------------
export async function itMe() {
  try {
    const res = await api.get("/it/me");
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e));
  }
}

// --------------------
// Requests
// --------------------
export async function createITRequest(payload) {
  try {
    const res = await api.post("/it/requests", payload);
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e));
  }
}

export async function listMyITRequests() {
  try {
    const res = await api.get("/it/requests/my");
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e));
  }
}

export async function listPendingApprovals() {
  try {
    const res = await api.get("/it/requests/pending");
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e));
  }
}

export async function adminListITRequests({
  status,
  request_type,
  q,
  limit = 50,
  offset = 0,
} = {}) {
  try {
    const params = { limit, offset };
    if (status) params.status = status;
    if (request_type) params.request_type = request_type;
    if (q) params.q = q;

    const res = await api.get("/it/requests", { params });
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e));
  }
}

export async function getITRequest(requestId) {
  try {
    const res = await api.get(`/it/requests/${requestId}`);
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e));
  }
}

export async function decideITRequest(requestId, decision, comment = null) {
  try {
    const res = await api.post(`/it/requests/${requestId}/decision`, { decision, comment });
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e));
  }
}

export async function addITComment(requestId, comment) {
  try {
    // comment travels as a query param, matching the original endpoint
    // contract (POST with no body, ?comment=... in the URL)
    const res = await api.post(`/it/requests/${requestId}/comment`, null, {
      params: { comment },
    });
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e));
  }
}

// --------------------
// Attachments
// --------------------
export async function uploadITAttachment(requestId, file) {
  const form = new FormData();
  form.append("file", file);
  try {
    const res = await api.post(`/it/requests/${requestId}/attachments`, form, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e));
  }
}

export async function downloadITAttachment(attachmentId, filename = "attachment") {
  let blob;
  try {
    const res = await api.get(`/it/attachments/${attachmentId}/download`, {
      responseType: "blob",
    });
    blob = res.data;
  } catch (e) {
    throw new Error(getApiError(e));
  }

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

// --------------------
// Chatbot
// --------------------
export async function itChat(message) {
  try {
    const res = await api.post("/it/chat", { message });
    return res.data;
  } catch (e) {
    throw new Error(getApiError(e));
  }
}
